// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICreateToken } from './ICreateToken';
import {
    ICreateTokenFromJSON,
    ICreateTokenFromJSONTyped,
    ICreateTokenToJSON,
    ICreateTokenToJSONTyped,
} from './ICreateToken';

/**
 * 
 * @export
 * @interface ICreateTokenRequest
 */
export interface ICreateTokenRequest {
    /**
     * 
     * @type {ICreateToken}
     * @memberof ICreateTokenRequest
     */
    token: ICreateToken;
    /**
     * 
     * @type {boolean}
     * @memberof ICreateTokenRequest
     */
    public_key_required?: boolean;
}

/**
 * Check if a given object implements the ICreateTokenRequest interface.
 */
export function instanceOfICreateTokenRequest(value: object): value is ICreateTokenRequest {
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}

export function ICreateTokenRequestFromJSON(json: any): ICreateTokenRequest {
    return ICreateTokenRequestFromJSONTyped(json, false);
}

export function ICreateTokenRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICreateTokenRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'token': ICreateTokenFromJSON(json['token']),
        'public_key_required': json['publicKeyRequired'] == null ? undefined : json['publicKeyRequired'],
    };
}

export function ICreateTokenRequestToJSON(json: any): ICreateTokenRequest {
    return ICreateTokenRequestToJSONTyped(json, false);
}

export function ICreateTokenRequestToJSONTyped(value?: ICreateTokenRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': ICreateTokenToJSON(value['token']),
        'publicKeyRequired': value['public_key_required'],
    };
}

